import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LocalStorageService } from 'src/app/_services/localStorage.service';

@Component({
  selector: 'app-confidential-modal',
  templateUrl: './confidential-modal.component.html',
  styleUrls: ['./confidential-modal.component.scss'],
  standalone: false,
})
export class ConfidentialModalComponent {
  role: any;

  constructor(
    private modalController: ModalController,
    private localStorageService: LocalStorageService
  ) {
    this.role = this.localStorageService.getUserRole();
  }

  closeModal() {
    this.modalController.dismiss();
  }
}

